import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';

// services
import { NavigationService } from '@sideline/sideline-apps-shared';
import { LayoutService } from '@templates/verona/layout/service/layout.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
  imports: [
    RouterOutlet
  ],
})
export class App {
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor(
    private layoutService: LayoutService,
    private navService: NavigationService,
  ) {
    effect(async () => {
      const eventType = this.keycloakSignal().type;
      if (eventType === KeycloakEventType.AuthError || eventType === KeycloakEventType.AuthRefreshError) {
        await this.navService.signOut();
      }
    });

      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('app-dark');
        this.layoutService._config.darkTheme = true;
      }
  }

  // ngOnInit() {
  //   this.router.events.subscribe(event => {
  //     if (event instanceof NavigationEnd) {
  //       console.log('Route changed to:', event.url);
  //       console.log('Route changed to:', event.urlAfterRedirects);
  //     }
  //   });
  // }
}
